/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reply_To_MessageInputs */

const en_reply_to_message = /** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply to Message`)
};

const es_reply_to_message = /** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder al Mensaje`)
};

const fr_reply_to_message = /** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondre au message`)
};

const de_reply_to_message = /** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Nachricht antworten`)
};

const id_reply_to_message = /** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balas Pesan`)
};

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const ja_reply_to_message = en_reply_to_message;

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const zh_reply_to_message = en_reply_to_message;

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const ar_reply_to_message = en_reply_to_message;

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const it_reply_to_message = en_reply_to_message;

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const ru_reply_to_message = en_reply_to_message;

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const pt_reply_to_message = en_reply_to_message;

/** @type {(inputs: Reply_To_MessageInputs) => LocalizedString} */
const ko_reply_to_message = en_reply_to_message;

/**
* | output |
* | --- |
* | "Reply to Message" |
*
* @param {Reply_To_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reply_to_message = /** @type {((inputs?: Reply_To_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reply_To_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reply_to_message(inputs)
	if (locale === "es") return es_reply_to_message(inputs)
	if (locale === "fr") return fr_reply_to_message(inputs)
	if (locale === "de") return de_reply_to_message(inputs)
	if (locale === "ja") return ja_reply_to_message(inputs)
	if (locale === "zh") return zh_reply_to_message(inputs)
	if (locale === "ar") return ar_reply_to_message(inputs)
	if (locale === "id") return id_reply_to_message(inputs)
	if (locale === "it") return it_reply_to_message(inputs)
	if (locale === "ru") return ru_reply_to_message(inputs)
	if (locale === "pt") return pt_reply_to_message(inputs)
	return ko_reply_to_message(inputs)
});